export default __webpack_public_path__ + "static/media/boo.c49f7355.gif";